import LeadTablePage from "components/JCL/LeadTablePage";
export default function MyLeads() { return <LeadTablePage mine />; }
